import logger from './logger';

/**
 * Log a custom Firebase Analytics event.
 * @param {string} name - Event name
 * @param {object} params - Optional event parameters
 */
export const logEvent = (name, params = {}) => {
    if (window.firebase) {
        logger.debug('[Analytics] logEvent:', name, params);
        window.firebase.analytics().logEvent(name, params);
    } else {
        logger.warn('[Analytics] Firebase not loaded, skipping logEvent:', name);
    }
};

/**
 * Log a screen view event — appears under "Pages and screens" in Firebase.
 * screenClass should match the Android Activity name for cross-platform consistency.
 * @param {string} screenName - Human-readable screen name
 * @param {string} screenClass - Screen class (match Android Activity name, e.g. 'KidAreaActivity')
 */
export const logScreenView = (screenName, screenClass) => {
    logEvent('screen_view', {
        firebase_screen: screenName,
        firebase_screen_class: screenClass,
    });
};
